<template>
    <a @click.prevent="handleClick" style="border-bottom: 1px solid #dedede;">
        <slot />
    </a>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, onUnmounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
const emit = defineEmits(['change'])
const props = defineProps({
    href: {
        type: String,
        default: ''
    }
})
interface IState {
    fileurl: string
    loading: boolean
    reloadInterval: any
    loadlist: any[]
}
const state = reactive<IState>({
    fileurl: '',
    loading: false,
    reloadInterval: {
        timer: null,
        time: 2000
    },
    loadlist: []
})
onMounted(() => {
    if (props.href) {
        state.fileurl = String(props.href)
    } else {
        state.fileurl = ''
    }
})
onUnmounted(() => {
    if (state.reloadInterval.timer) {
        clearInterval(state.reloadInterval.timer)
    }
})
const handleClick = () => {
    if (state.fileurl.indexOf('storage/public/uploads/') > 0) {
        let restoreUrl = 'public/uploads/' + state.fileurl.split('storage/public/uploads/')[1]
        restoreUrl = restoreUrl.split('?')[0]
        checkHaveFile(restoreUrl)
    }
}
//检查是否有存储
const checkHaveFile = (url) => {
    if (state.loadlist.indexOf(url) > -1) {
        return
    }
    state.loadlist.push(url)
    state.loading = true
    let requestParam = {
        url: '/admin/v1/restoreShow',
        method: 'post',
        data: {
            url: url,
            axiosStep: 3
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data == 1) {
                //文件已存在，直接刷新image
                openFile()
            } else if (res.data == 2) {
                // 文件不存在，需要去解冻
                setTimeout(() => {
                    reloadFile(url)
                }, 50);
            }
        })
        .catch((res) => {
            // if (res.msg) {
            //     message.error(res.msg)
            // } else {
            //     message.error('图片加载失败')
            // }
        })
        .finally(() => {
            state.loading = false
        })
}
const openFile = () => {
    window.open(state.fileurl, '_blank')
}
const reloadFile = (url) => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/restoreShow',
        method: 'post',
        data: { url: url }
    }
    baseServicePlus(requestParam, state.reloadInterval)
        .then((res: any) => {
            openFile()
        })
        .catch((res) => {
            // message.error(res.msg)
        })
        .finally(() => {
            state.loading = false
        })
}
watch(
    () => props.href,
    (val) => {
        if (val) {
            if (props.href) {
                state.fileurl = String(props.href)
            } else {
                state.fileurl = ''
            }
        }
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
